/* globals Class,jui,lp,$ */

lp.editor.BuilderModal = Class.create(jui.ModalDialog, {
  initialize: function($super, options) {
    $super(options);
    this.maximized = false;
    this.initialLayoutRules = this.layoutRules;
  },

  installUI: function($super) {
    $super();
  }
});

lp.editor.BuilderModal.fitToViewport = function() {
  var padding = 50;
  this.setOffset({ left: padding, top: padding });
  this.setDimensions({
    width: document.viewport.getWidth() - padding * 2,
    height: document.viewport.getHeight() - padding * 2
  });
};

lp.editor.BuilderModal.fitToEditor = function(options) {
  var headerHeight = $('header').getHeight();
  var padding = options.padding || 2;
  this.setOffset({left:padding, top:padding + headerHeight});
  this.setDimensions({width:document.viewport.getWidth() - padding*2, height:document.viewport.getHeight() - padding*2 - headerHeight});
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/builder_modal.js
// module id = 1007
// module chunks = 0